module.exports = __webpack_public_path__ + "static/media/australia.3717ae7b.svg";